import React from 'react';
import styled from 'styled-components';
import { IRadioOptionsProps, Radio } from './Radio';

// tslint:disable-next-line:variable-name
const SRadioGroup = styled.section<{}>(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

// tslint:disable-next-line:variable-name
const SRadio = styled(Radio)(({ theme }) => ({
  marginBottom: theme.spacing.medium,
})) as unknown as new <T>() => Radio<T>;

// tslint:disable-next-line:no-empty-interface
interface IRadioGroupProps<T> {
  name: string;
  radioOptions: Array<IRadioOptionsProps<T>>;
  value?: T;
  onChange: (value: T, name: string) => void;
  dataAt: string;
  className?: string;
}

export default class RadioGroup<T> extends React.Component<IRadioGroupProps<T>> {
  public static defaultProps = {
    className: '',
  };

  private handleOnClick = (value: T) => {
    this.props.onChange(value, this.props.name);
  };

  public render() {
    return (
      <SRadioGroup className={this.props.className} data-at={this.props.dataAt}>
        {this.props.radioOptions.map((radioOptions, index) => (
          <SRadio
            key={index}
            {...radioOptions}
            onClick={this.handleOnClick}
            selected={this.props.value === radioOptions.value}
          />
        ))}
      </SRadioGroup>
    );
  }
}
